import { useState, useEffect } from 'react';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  CustomTextField,
  CustomTextArea,
  CustomCheckbox,
  HorizontalForm,
  CustomButton,
} from '../../../common';
import { useSendMails } from '../../../hooks/useSubscribers';
import {
  capitalizeWords,
  generateEmailSubject,
  generateEmailMessage,
  getMostRecentCoupon,
} from '../utils/couponsMailsUtils';
import { Box } from '@mui/material';

const EmailDialog = ({ open, onClose, emailData, plans, onSendResult }) => {
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [note, setNote] = useState('');
  const [isNoteEnabled, setIsNoteEnabled] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState('no-user-email@gmail.com');

  const sendMailsMutation = useSendMails();

  const formattedName = emailData
    ? capitalizeWords(`${emailData.first_name} ${emailData.last_name}`)
    : '';

  useEffect(() => {
    if (open && emailData) {
      const planName =
        plans.find((plan) => plan.uuid === emailData.contract?.uuid_plan)?.name || '';
      const defaultSubject = generateEmailSubject(planName, emailData.contract_number);
      const defaultMessage = generateEmailMessage(formattedName, emailData, planName);

      const subscriberEmail = emailData.email || emailData.subscriber?.email;
      const normalizedEmail = subscriberEmail && subscriberEmail.trim() !== '' ? subscriberEmail : 'no-user-email@gmail.com';
      setRecipientEmail(normalizedEmail);
      setTo(normalizedEmail);
      setSubject(defaultSubject);
      setMessage(defaultMessage);
      setNote('');
      setIsNoteEnabled(false);
    }
  }, [open, emailData, plans, formattedName]);

  const handleSend = async () => {
    const mostRecentCoupon = getMostRecentCoupon(emailData.coupons);
    const uuidForFile = mostRecentCoupon?.uuid;
    const planName = plans.find((plan) => plan.uuid === emailData.contract?.uuid_plan)?.name || '';
    console.log(emailData.subscriber)
    const emailToSend = {
      emails: [
        {
          email: recipientEmail,
          to: to,
          subject: subject,
          text_message: message,
          name: formattedName,
          order_number: emailData.contract_number,
          coupons: emailData.coupons,
          plan_name: planName,
          attachment: 'NroOrden1-Año2023-Grupo0.pdf',
          note: note,
          uuidForFile: uuidForFile,
        },
      ],
    };

    try {
      const result = await sendMailsMutation.mutateAsync(emailToSend);
      
      if (onSendResult) {
        onSendResult(result);
      }
      
      onClose();
    } catch (error) {
      console.error('Error sending email:', error);
      
      if (onSendResult) {
        const errorResult = {
          message: "Error al enviar el email",
          summary: {
            total_emails: 1,
            successful_count: 0,
            failed_count: 1
          },
          successful_emails: [],
          failed_emails: [{
            email: formattedName,
            order_number: emailData.contract_number,
            uuid_for_file: uuidForFile,
            error: error.message || 'Error desconocido'
          }]
        };
        onSendResult(errorResult);
      }
      
      onClose();
    }
  };

  const handleNoteToggle = (checked) => {
    setIsNoteEnabled(checked);
    if (!checked) {
      setNote('');
    }
  };

  if (!emailData) return null;

  return (
    <DialogContainer open={open} onClose={onClose} size="large">
      <DialogTitle>Enviar Email</DialogTitle>

      <DialogBody>
        <HorizontalForm withBorder={false} sx={{ gap: 2, p: 0 }}>
          <CustomTextField
            label="Para:"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            disabled
            sx={{ mb: 2 }}
          />

          <CustomTextField
            label="De:"
            value="administracion@constructoracolonial.com.ar"
            disabled
            sx={{ mb: 2 }}
          />

          <CustomTextField
            label="Asunto:"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            disabled
            sx={{ mb: 2 }}
          />
        </HorizontalForm>
        <CustomTextArea
          label="Mensaje:"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled
          minRows={10}
          sx={{ mb: 2 }}
        />
        <HorizontalForm withBorder={false} sx={{ gap: 2, p: 0 }}>
          <CustomTextArea
            label="Nota:"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            disabled={!isNoteEnabled}
            minRows={2}
            placeholder="Escriba su nota aquí..."
          />
          <CustomCheckbox
            checked={isNoteEnabled}
            onChange={(e) => handleNoteToggle(e.target.checked)}
            label=""
          />
        </HorizontalForm>
      </DialogBody>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          p: 3,
          borderTop: '1px solid #e0e0e0',
        }}
      >
        <CustomButton onClick={onClose} variant="danger">
          Cancelar
        </CustomButton>

        <CustomButton onClick={handleSend} variant="base">
          Enviar
        </CustomButton>
      </Box>
    </DialogContainer>
  );
};

export default EmailDialog;
